const formatters = new Map<string, Intl.NumberFormat>();

export const getNumberFormatter = (
  locale: string,
  options: Intl.NumberFormatOptions = {}
) => {
  const key = `${locale}|${JSON.stringify(options)}`;
  let formatter = formatters.get(key);

  if (!formatter) {
    formatter = new Intl.NumberFormat(locale, options);
    formatters.set(key, formatter);
  }

  return formatter;
};
